import { useNavigate } from "react-router-dom";
import { useCreateContact } from "@/hooks/use-contacts";
import { useToast } from "@/contexts";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import { ArrowLeft } from "lucide-react";
import {
  ContactForm,
  ContactFormData,
} from "../../components/organisms/ContactForm";

export function ContactCreate() {
  const navigate = useNavigate();
  const createContact = useCreateContact();
  const { showError, showSuccess } = useToast();

  const handleSubmit = async (data: ContactFormData) => {
    try {
      // Convert null to undefined for API compatibility
      const body = {
        ...data,
        priceMin: data.priceMin ?? undefined,
        priceMax: data.priceMax ?? undefined,
      };
      await createContact.mutateAsync({ body });
      showSuccess("Contact created successfully");
      navigate("/contacts");
    } catch (error) {
      const message =
        error instanceof Error ? error.message : "Failed to create contact";
      showError(message);
    }
  };

  const handleCancel = () => {
    navigate("/contacts");
  };

  return (
    <Box>
      <Button
        startIcon={<ArrowLeft size={20} />}
        onClick={() => navigate("/contacts")}
        sx={{ mb: 3 }}
      >
        Back to Contacts
      </Button>

      <Typography variant="h4" component="h1" sx={{ mb: 3 }}>
        Add New Contact
      </Typography>

      <Paper sx={{ p: 3 }}>
        <ContactForm
          onSubmit={handleSubmit}
          onCancel={handleCancel}
          isLoading={createContact.isPending}
        />
      </Paper>
    </Box>
  );
}
